/*jshint esversion: 6 */

import $ from "jquery";

function navigationToggle() {
  let $body = $("body");
  let $mobileToggle = $(".page-header__nav-toggle");
  let mobileToggleOpenClass = "page-header__nav-toggle--open";
  let bodyOpenClass = "navigation-open";

  $(".page-overlay-navigation__main-navigation a").on("click", () => {
    $body.removeClass(bodyOpenClass);
    $mobileToggle
      .removeClass(mobileToggleOpenClass)
      .attr("aria-expanded", false);
  });

  $mobileToggle.on("click", () => {
    if ($mobileToggle.hasClass(mobileToggleOpenClass)) {
      $body.removeClass(bodyOpenClass);
      $mobileToggle
        .removeClass(mobileToggleOpenClass)
        .attr("aria-expanded", false);
    } else {
      $mobileToggle.addClass(mobileToggleOpenClass).attr("aria-expanded", true);

      $body.addClass(bodyOpenClass);
    }
  });
}

export default navigationToggle;
